import data from "../config/changelog.json";

const KEY = "paws.changelog";
export const PENDING_VERSION = "next";

export const entries = () => (Array.isArray(data.entries) ? data.entries : []);

export const entryKey = (entry, appVersion) =>
  (!entry ? "" : entry.version === PENDING_VERSION ? `${PENDING_VERSION}:${appVersion}` : entry.version);

export function latestEntry(list = entries()) {
  return list.length ? list[0] : null;
}

export function seenKey(storage = globalThis.localStorage) {
  try {
    return storage?.getItem(KEY) || "";
  } catch {
    return "";
  }
}

export function markSeen(entry, appVersion, storage = globalThis.localStorage) {
  const key = entryKey(entry, appVersion);
  if (!key) return false;
  try {
    storage?.setItem(KEY, key);
    return true;
  } catch {
    return false;
  }
}

export function pendingEntry({ appVersion, list = entries(), storage = globalThis.localStorage } = {}) {
  const entry = latestEntry(list);
  if (!entry || !entry.changes?.length) return null;
  return entryKey(entry, appVersion) === seenKey(storage) ? null : entry;
}

export function entryTitle(entry, appVersion) {
  const version = entry?.version === PENDING_VERSION ? appVersion : entry?.version;
  return [`Novità v${version || "?"}`, entry?.titolo].filter(Boolean).join(" · ");
}

export function groupByArea(entry) {
  const groups = new Map();
  for (const change of entry?.changes || []) {
    const area = change.area || "Varie";
    if (!groups.has(area)) groups.set(area, []);
    groups.get(area).push(change);
  }
  return [...groups.entries()];
}
